export const CACHE_KEY_LIST_USERS = 'users';
export const CACHE_KEY_USERS = 'users-one';
export const ROUTE_PATH_USERS = '/users/users/list';
export const TRANSLATION_PREFIX_USERS = 'users';

